import React from "react";

const RealTimeTracking = ({ trackingData }) => {
  const statuses = trackingData?.statuses || trackingData || [];
  const podLinks = trackingData?.orderInformation?.pod_links || [];

  if (!statuses || statuses.length === 0) {
    return (
      <div className="real-time-tracking">
        <h3>Real Time Tracking</h3>
        <p>No tracking information available</p>
      </div>
    );
  }

  // Create a copy to avoid mutating original data and preserve API order
  const sortedStatuses = [...statuses];

  const formatDateTime = (ts) => {
    try {
      // Handle null or invalid timestamps
      if (!ts || ts === null) return "-";

      // Handle both string and number timestamps
      const timestamp = typeof ts === "string" ? parseInt(ts) : ts;

      // Check if timestamp is valid
      if (isNaN(timestamp) || timestamp <= 0) return "-";

      const d = new Date(timestamp);

      // Check if date is valid
      if (isNaN(d.getTime())) return "-";

      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yyyy = d.getFullYear();
      let hours = d.getHours();
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // 0 -> 12
      const hh = String(hours).padStart(1, "0");
      return `${dd}/${mm}/${yyyy}, ${hh}:${minutes}:${seconds} ${ampm}`;
    } catch (e) {
      return "-";
    }
  };

  return (
    <div className="real-time-tracking">
      <h3>Real Time Tracking</h3>
      <div className="tracking-timeline">
        {sortedStatuses.map((status, idx) => (
          <div key={idx} className="timeline-item">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <div className="status-title">
                {status.status.replace(/_/g, " ")}
              </div>
              <div className="status-time">
                {formatDateTime(status.statusTimestamp)}
              </div>
              <div className="status-description">
                {status.category && (
                  <div
                    className="status-category"
                    style={{ fontSize: "12px", fontWeight: "500" }}
                  >
                    {status.category.replace(/_/g, " ")}
                  </div>
                )}
                <div
                  className="status-subcategory"
                  style={{ fontSize: "12px" }}
                >
                  {status.subcategory}
                  {status.location &&
                    status.status.toLowerCase() !== "ready_for_dispatch" &&
                    ` (${status.location})`}
                  {status.status.toLowerCase().includes("delivered") &&
                    status.status.toLowerCase() !== "undelivered" &&
                    status.status.toLowerCase() !== "rto_undelivered" &&
                    !(
                      new URLSearchParams(window.location.search).get("pod") ===
                        "false" ||
                      window.location.pathname.includes("/pod=false")
                    ) &&
                    podLinks &&
                    podLinks.length > 0 &&
                    podLinks[0] && (
                      <span style={{ marginLeft: 5 }}>
                        [
                        <a
                          style={{
                            color: "#238EF8",
                            fontWeight: "bold",
                            cursor: "pointer",
                          }}
                          href={podLinks[0]}
                          target="_blank"
                          rel="noreferrer"
                        >
                          VIEW POD
                        </a>
                        ]
                      </span>
                    )}
                </div>
              </div>
              {status.event &&
                (status.status.toLowerCase() === "undelivered" ||
                  status.status.toLowerCase().includes("rto")) && (
                  <div className="status-description">
                    Reason: {status.event}
                  </div>
                )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RealTimeTracking;
